import axios from 'axios'
import { URL_BACKOFFICE } from '@/configs'
import { getAuthHeader } from '@/firebase/config'

const { get, post, put } = axios

export const listPortalUsers = async () =>
  get(`${URL_BACKOFFICE}/portal/users`, await getAuthHeader()).then(
    ({ data }: any) =>
      data.map((t: any, idx: number) => ({
        idx: idx + 1,
        ...t,
      }))
  )

export const createPortalUser = async (email: string) =>
  post(`${URL_BACKOFFICE}/portal/users`, { email }, await getAuthHeader())

export const resetPasswordPortalUser = async (uid: string) =>
  put(
    `${URL_BACKOFFICE}/portal/users/${uid}/reset-password`,
    null,
    await getAuthHeader()
  )

export default {
  listPortalUsers,
  createPortalUser,
  resetPasswordPortalUser,
}
